export const DEFAULT_COMPANY_CONFIG = {
	'name': 'Jubilant',
	'url': 'https://erp.jubilantmingkok.com',
	'logo': '/assets/img/logo.png',
	'bg': '/assets/img/bg.jpg',
  'serial_no': 'SYS-01'
}
